const Token = (props) => {
    return (
        <div className="p-2">
            <h2 className="text-lg font-semibold mb-2">Asociar token</h2>
            <div className='flex flex-row justify-between w-1/2 items-center'>
                <label>El token actual del socio es: </label>
                <input 
                    type="text" 
                    value={props.socio?.token && parseInt(props.socio.token) ? props.socio.token : ''} 
                    onChange={(e) => props.setSocio({...props.socio, token: e.target.value})} 
                    className="border border-gray-300 rounded px-2 w-32"
                />
            </div>
            {/* Aquí podrías agregar más funcionalidades relacionadas con el token */}
        </div>
    )
}

export default Token    


